import { DiagnosticPartner } from '@malou-io/package-utils';

export interface PartnerThemeBackground {
    type: 'image' | 'color';
    value: string;
}

export interface PartnerThemeConfig {
    header: {
        logoPath: string;
        tagline: string;
        primaryColor: string;
        secondaryColor: string;
    };
    /** Font family to use for section titles (e.g. 'Futura BT'). Falls back to Poppins if unset. */
    titleFont?: string;
    /** Color for primary CTA buttons (e.g. '#c94603'). Falls back to primaryColor if unset. */
    ctaColor?: string;
    /** Color for the positive segment in semantic analysis charts. Falls back to default green if unset. */
    chartPositiveColor?: string;
    /** Color for the negative segment in semantic analysis charts. Falls back to default red if unset. */
    chartNegativeColor?: string;
    /** Optional illustration shown in the competitors CTA panel. */
    competitorsIllustrationPath?: string;
    footer: {
        poweredByText: string;
        showRestaurantLogos: boolean;
    };
    background?: PartnerThemeBackground;
    zeroDisplayedValue?: string;
}

export const PARTNER_THEME_CONFIGS: Record<DiagnosticPartner, PartnerThemeConfig> = {
    [DiagnosticPartner.GMP]: {
        header: {
            logoPath: 'assets/logos/partners/logo-color.png',
            tagline: 'Un service de Grands Moulins de Paris',
            primaryColor: '#0a0b55',
            secondaryColor: '#181e8c',
        },
        titleFont: 'Futura BT',
        ctaColor: '#c94603',
        chartPositiveColor: '#4BA852',
        chartNegativeColor: '#E5173D',
        competitorsIllustrationPath: 'assets/images/partners/gmp-gimmick.png',
        footer: {
            poweredByText: 'Powered by Malou',
            showRestaurantLogos: false,
        },
        background: {
            type: 'image',
            value: 'assets/images/partners/gmp-background.jpg',
        },
        zeroDisplayedValue: '0',
    },
};
